module.exports = __webpack_public_path__ + "img/goal.03f2021e.svg";